import {Injectable} from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";

@Injectable()
export class LoaderService {

  private counter: number = 0;

  constructor(private spinner: NgxSpinnerService) {
  }

  show() {
    this.counter++;
    if (this.counter == 1) {
      this.spinner.show();
    }
  }

  hide() {
    if (this.counter > 0) {
      this.counter--;
    }
    if (this.counter == 0) {
      this.spinner.hide();
    }
  }

}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/service/loader.service.ts